// libs
import dayjs from 'dayjs';
import { CampaignStatus, CampaignStatusUpdateReason, } from '@local/typedefs/dist/protos/campaign/Campaign';
// constants
import { CampaignStatusMapEnum } from '@/constants/campaign';
import { DaysOfWeekMap, MealSlotMap } from '@/constants/Misc';
export const formatCampaignData = (key, campaign, cityOptions) => {
    var _a, _b, _c;
    switch (key) {
        case 'status':
            if (campaign && campaign[key]) {
                return getMappedCampaignStatus(campaign[key], campaign.statusUpdateReason);
            }
            return '';
        case 'startDate':
            if (campaign && campaign[key]) {
                return dayjs(campaign[key]).format('MMM DD, YYYY');
            }
            return '';
        case 'endDate':
            if (campaign && campaign[key]) {
                return dayjs(campaign[key]).format('MMM DD, YYYY');
            }
            return '';
        case 'daysOfWeek':
            if (campaign && campaign.adGroups[0][key]) {
                const days = campaign.adGroups[0][key].slice(0, 3);
                if (!days)
                    return '';
                return days
                    .map((day) => day.charAt(0).toUpperCase() +
                    day.slice(1).toLowerCase())
                    .join(', ');
            }
            return '';
        case 'daysOfWeek-plus':
            if (campaign && campaign.adGroups[0]['daysOfWeek']) {
                if (campaign.adGroups[0]['daysOfWeek'].length > 3)
                    return ('+' +
                        (campaign.adGroups[0]['daysOfWeek'].length - 3).toString() +
                        ' more');
            }
            return '';
        case 'mealSlots':
            if (campaign && campaign.adGroups[0][key]) {
                const mealSlots = campaign.adGroups[0][key];
                return mealSlots === null || mealSlots === void 0 ? void 0 : mealSlots.map((slot) => MealSlotMap[slot].label).join(', ');
            }
            return '';
        case 'pacingEnabled':
            if (campaign && typeof campaign[key] !== 'undefined') {
                return campaign[key] ? 'Enabled' : 'Disabled';
            }
            return '';
        case 'products-keywords':
            return `${(_a = campaign === null || campaign === void 0 ? void 0 : campaign.adGroups[0].candidates) === null || _a === void 0 ? void 0 : _a.length} Products, ${(_b = campaign === null || campaign === void 0 ? void 0 : campaign.adGroups[0].keywords) === null || _b === void 0 ? void 0 : _b.length} Keywords`;
        case 'cities':
            if (campaign && campaign.adGroups[0]['cityIds']) {
                const cities = campaign.adGroups[0]['cityIds'].slice(0, 3);
                return cities
                    .map((cityId) => {
                    const city = cityOptions === null || cityOptions === void 0 ? void 0 : cityOptions.find((city) => city.id == cityId.toString());
                    return (city === null || city === void 0 ? void 0 : city.value) || '';
                })
                    .join(', ');
            }
            return '';
        case 'cities-plus':
            if (campaign && campaign.adGroups[0]['cityIds']) {
                const cities = campaign.adGroups[0]['cityIds'];
                if (cities.length > 3)
                    return '+' + (cities.length - 3).toString() + ' more';
                return '';
            }
            return '';
        default:
            if (campaign && campaign[key])
                return (_c = campaign[key]) === null || _c === void 0 ? void 0 : _c.toString();
            return '-';
    }
};
export const getMappedCampaignStatus = (status, statusUpdateReason) => {
    if (status === CampaignStatus.CAMPAIGN_STATUS_LIVE)
        return CampaignStatusMapEnum.ACTIVE;
    if (status === CampaignStatus.CAMPAIGN_STATUS_BOOKED &&
        statusUpdateReason ===
            CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_INVALID)
        return CampaignStatusMapEnum.BOOKED;
    if (status === CampaignStatus.CAMPAIGN_STATUS_STOPPED &&
        statusUpdateReason ===
            CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_EXPIRED)
        return CampaignStatusMapEnum.EXPIRED;
    if (status === CampaignStatus.CAMPAIGN_STATUS_STOPPED &&
        statusUpdateReason ===
            CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_BUDGET_EXHAUSTED)
        return CampaignStatusMapEnum.EXHAUSTED;
    if (status === CampaignStatus.CAMPAIGN_STATUS_STOPPED &&
        statusUpdateReason ===
            CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_UPDATED_BY_ADVERTISER)
        return CampaignStatusMapEnum.STOPPED;
    return CampaignStatusMapEnum.INVALID;
};
export const checkEditableStatus = (status) => {
    return !!(status === CampaignStatus.CAMPAIGN_STATUS_BOOKED ||
        status === CampaignStatus.CAMPAIGN_STATUS_LIVE);
};
export const getCityNames = (cityIds = [], cityOptions) => {
    return cityIds
        .map((cityId) => {
        const city = cityOptions === null || cityOptions === void 0 ? void 0 : cityOptions.find((city) => city.id === cityId.toString());
        return city === null || city === void 0 ? void 0 : city.value;
    })
        .filter(Boolean);
};
export const getMealSlotsLabels = (mealSlots = []) => {
    return mealSlots.map((slot) => MealSlotMap[slot].label);
};
export const getDaysOfWeekLabels = (daysOfWeek = []) => {
    return daysOfWeek.map((day) => DaysOfWeekMap[day].label);
};
